export default "__VITE_ASSET__TZg18Ixs__"